import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IProviderCellProps } from './provider-cell.types';

export const ProviderCell: FC<IProviderCellProps> = ({ broadcast }) => {
  const { t } = useTranslation();

  return (
    <>
      {t(`provider.${broadcast.providerType}`, {
        defaultValue: broadcast.providerType,
      })}
    </>
  );
};
